<template>
  <div class="mobileViewStyle deduct-detail">
    <!-- 新增扣分（企业微信手机端）：扣分只登记、不做编辑 -->
    <div class="detail-body">
      <list-card label="扣分信息" type="form">
        <data-input label="员工">
          <mobile-search-select v-model="editData.employeeId" :query="queryStaffPage"
                                label-column="employeeName" code-column="employeeId"
                                placeholder="请选择员工" search-placeholder="员工姓名"
                                :display-text="employeeName" @change="onStaffChange">
            <!-- 职员按「头像 + 名称 / 手机号」两行显示（预览模板 B） -->
            <template #item="{item}">
              <div class="mss-item mss-item-avatar-row">
                <div class="mss-item-avatar">
                  <img v-if="item.iconUrl" :src="$getImageUrl(item.iconUrl)" alt=""/>
                  <yq-icon v-else name="element-ui_user"/>
                </div>
                <div class="mss-item-info">
                  <div class="mss-item-main">{{ item.employeeName }}</div>
                  <div class="mss-item-sub">{{ item.employeePhone || "无联系电话" }}</div>
                </div>
              </div>
            </template>
          </mobile-search-select>
        </data-input>
        <data-input label="考核项">
          <mobile-select class="row-select" :clearable="false" v-model="editData.itemId"
                         placeholder="先选员工，按他的 KPI 类型过滤" @change="onItemChange">
            <mobile-option v-for="item in itemOptions" :key="item.id"
                           :label="item.kpiName + '（上限 ' + item.cap + '）'" :value="item.id"/>
          </mobile-select>
        </data-input>
        <data-input label="扣分分值" v-model="editData.points" desc="" placeholder="大于 0，可带一位小数"/>
        <data-input label="扣分日期">
          <mobile-date-select v-model="editData.deductionDate" placeholder="请选择扣分日期"/>
        </data-input>
        <data-input label="扣分原因" v-model="editData.reason" desc="" placeholder="简要说明扣分原因"/>
      </list-card>
    </div>

    <div class="detail-footer">
      <mobile-button @click="cancel">取消</mobile-button>
      <mobile-button el-type="primary" @click="saveData">登记扣分</mobile-button>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataInput from "@/components/qywx/data/DataInput.vue";
import MobileSelect from "@/components/qywx/data/MobileSelect.vue";
import MobileOption from "@/components/qywx/data/MobileOption.vue";
import MobileSearchSelect from "@/components/qywx/data/MobileSearchSelect.vue";
import MobileDateSelect from "@/components/qywx/data/MobileDateSelect.vue";
import MobileButton from "@/components/qywx/button/MobileButton.vue";
import deductionApi from "@/api/dz-crm/kpi/deductionApi";
import kpiItemApi from "@/api/dz-crm/kpi/kpiItemApi";
import calendarApi from "@/api/dz-crm/kpi/calendarApi";
import commonApi from "@/api/commonApi";

/** 取本地当天的 yyyy-MM-dd。不能用 toISOString()：它是 UTC，东八区凌晨会退到前一天 */
function today() {
  const d = new Date();
  const pad = n => String(n).padStart(2, "0");
  return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
}

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "DD",
  components: {
    MobileButton, MobileSearchSelect, MobileDateSelect, MobileOption, MobileSelect, DataInput, ListCard
  },
  data() {
    return {
      editData: {
        employeeId: "",
        employeeName: "",
        itemId: "",
        points: "",
        // 默认当天
        deductionDate: today(),
        reason: "",
      },
      employeeName: "", // 员工回显（组件内维护选中项，这里只在首屏给个初始文案）
      itemOptions: [],
      // POSITION_ROLE 字典：职员的 kpiType 是字典 code，要换成字典项 id 才能查考核项
      kpiTypeDictList: [],
      pageTitle: "",
    };
  },
  created() {
    this.pageTitle = document.title;
    document.title = "新增扣分";
    commonApi.queryUniqueDictionaryList("POSITION_ROLE").then(list => this.kpiTypeDictList = list || []);
  },
  unmounted() {
    document.title = this.pageTitle;
  },
  methods: {
    /**
     * 员工选择框的数据源。
     * 平台职员接口是一次性返回的数组（非分页），这里包一层适配通用选择组件。
     */
    queryStaffPage(params) {
      return calendarApi.queryEmployeeStaff({}).then(list => {
        const keyword = (params.searchKey || "").trim();
        const records = keyword
            ? (list || []).filter(item => (item.employeeName || "").indexOf(keyword) > -1
                || (item.employeePhone || "").indexOf(keyword) > -1)
            : (list || []);
        return {records, pageCount: 1};
      });
    },
    /**
     * 选员工后按他的 KPI 类型（岗位）拉考核项。
     * 职员角色 → kpiType 是 POSITION_ROLE 字典的 code → 换成字典项 id → 查考核项
     */
    async onStaffChange(record) {
      // 换人后文案交给组件自己维护；考核项要跟着清掉，否则会留上一个员工的可选项
      this.employeeName = "";
      this.editData.itemId = "";
      this.itemOptions = [];
      if (!record) {
        this.editData.employeeName = "";
        return;
      }
      this.editData.employeeName = record.employeeName || "";
      if (!record.kpiType) {
        this.$message.warning("该职员的角色未设置岗位类型，无法选择考核项");
        return;
      }
      const dictItem = this.kpiTypeDictList.find(item => item.dictCode === record.kpiType);
      const kpiId = dictItem ? dictItem.id : record.kpiType;
      // kpiItem.queryList 返回数组（非 PageBean），勿用 {records} 解构
      const list = await kpiItemApi.queryList({kpiPositionId: kpiId});
      this.itemOptions = list || [];
      if (!this.itemOptions.length) {
        this.$message.warning("该 KPI 类型下还没有考核项，请先到考核项设置中添加");
      }
    },
    /** 选考核项后带出名称，保存时一并提交（后端没带也会按 id 回填） */
    onItemChange(itemId) {
      const item = this.itemOptions.find(option => option.id === itemId);
      this.editData.itemName = item ? item.kpiName : "";
    },
    cancel() {
      this.router.back();
    },
    saveData() {
      if (!this.editData.employeeId) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.editData.itemId) {
        this.$message.error("请选择考核项");
        return;
      }
      if (!(Number(this.editData.points) > 0)) {
        this.$message.error("请输入大于 0 的扣分值");
        return;
      }
      if (!this.editData.deductionDate) {
        this.$message.error("请选择扣分日期");
        return;
      }
      if (!this.editData.reason) {
        this.$message.error("请填写扣分原因");
        return;
      }
      const payload = JSON.parse(JSON.stringify(this.editData));
      payload.points = Number(payload.points);
      // 成功提示由请求拦截器统一弹（save 接口）
      deductionApi.save(payload).then(() => this.router.back());
    }
  }
};
</script>

<style lang="scss" scoped>
.deduct-detail{
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--yq-background-color);
  .detail-body{
    flex: 1;
    overflow-y: auto;
    padding: 10px;
  }
  .detail-footer{
    flex: none;
    display: flex;
    gap: 10px;
    padding: 10px;
    background: #FFF;
    box-shadow: 0 -1px 4px var(--yq-shadow);
    :deep(.mobile-button){
      flex: 1;
    }
  }
  // 选择类控件放在 data-input 行里：去掉自带边框/箭头，字号跟随整行
  :deep(.row-select .select-area){
    width: auto;
    box-shadow: none;
    padding: 0;
    background: transparent;
    font-size: inherit;
    color: var(--yq-font-color-base);
    .value{
      flex: none;
      width: auto;
      max-width: 220px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: right;
      &.placeholder{
        color: var(--yq-font-color-desc);
      }
    }
    .arrow-down{
      display: none;
    }
  }
}
</style>
